import Bold from "@tiptap/extension-bold";
import {mergeAttributes} from "@tiptap/core";

/**
 * Eigene Bold-Extension für Tiptap v2, abgeleitet von der offiziellen
 * @tiptap/extension-bold (Struktur/Vorbild analog zur eigenen FontSize.js
 * für textStyle). Ergänzt das gerenderte <strong> zusätzlich um ein hartes
 * inline font-weight:700.
 *
 * Grund: Bootstraps globales "b, strong { font-weight: bolder }" ist ein
 * RELATIVER Wert. Ausgehend vom projektweiten $font-weight-base: 300 (siehe
 * app.scss) ergibt "bolder" nur 400 - optisch kaum von normalem Text zu
 * unterscheiden. Damit Fettschrift auch unabhängig von den Standard-
 * einstellungen des jeweiligen Mailprogramms sichtbar ankommt, bekommt
 * <strong> hier zusätzlich ein festes inline font-weight:700 mit - dieses
 * überschreibt jede relative Vorgabe (weder Editor-CSS noch ein fremder
 * Mail-Client können "bolder" mehr hineinfunken).
 *
 * @see https://tiptap.dev/api/marks/bold (Vorlage/Basis-Extension)
 */
const BoldWithInlineStyle = Bold.extend({
    renderHTML({HTMLAttributes}) {
        return [
            "strong",
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                style: "font-weight:700",
            }),
            0,
        ];
    },
});

export default BoldWithInlineStyle;
